const boolAnswers = {
    YES: 'y',
    NO: 'n'
};

const egTemplatePages = [
    'email/verified',
    'email/verified/error'
];

const pathSources = {
    ULX: 'ulx',
    addProperty: 'pco_add_property',
    addPropertyV2: 'pco_add_property_v2',
    addPropertyMarket: 'pco_add_property_market'
};

const pathUrls = {
    [pathSources.addProperty]: {
        test: 'https://apps.expediapartnercentral.com.integration.sb.karmalab.net/onboarding/addProperty',
        prod: 'https://apps.expediapartnercentral.com/onboarding/addProperty'
    },
    [pathSources.addPropertyMarket]: 'pco_add_property_market'
};

const propertyTypes = {
    HOTEL: 'hotel',
    HOUSE: 'house',
    MORE: 'more'
};

const softwareBrands = {
    HA: 'homeaway',
    EXPEDIA: 'expedia'
};

const destinations = {
    LPS: 'lps',
    LPS_MARKETING: 'lpsMarketing',
    VRBO: 'vrbo',
    VRBO_PM: 'vrboPm'
};

const templates = {
    BEX: 'bex',
    EG: 'eg',
    VRBO: 'vrbo',
    AEM: 'aem',
    MVP: 'mvp'
};

// If the host part of the domain isn't listed here, you get the default theme
const themes = {
    expedia: 'eg',
    expediapartnercentral: 'eg',
    vrbo: 'vrbo',
    homeaway: 'gt',
    abritel: 'gt',
    'fewo-direkt': 'gt',
    vacationrentals: 'gt',
    homelidays: 'gt',
    aluguetemporada: 'gt'
};

// If the host part of the domain isn't listed here, you get default branding
const supportedBrands = {
    expedia: 'expedia',
    expediapartnercentral: 'expedia',
    vrbo: 'vrbo',
    away: 'vrbo',
    homeaway: 'homeaway',
    abritel: 'abritel',
    'fewo-direkt': 'fewo-direkt',
    vacationrentals: 'vacation-rentals',
    homelidays: 'homelidays',
    aluguetemporada: 'aluguetemporada',
    stayz: 'stayz',
    bookabach: 'bookabach'
};

// If the host part of the domain isn't listed here, you get default branding
const supportedBrandNames = {
    expedia: 'Expedia',
    vrbo: 'Vrbo',
    homeaway: 'HomeAway',
    abritel: 'Abritel',
    'fewo-direkt': 'FeWo-direkt',
    'vacation-rentals': 'VacationRentals',
    homelidays: 'Homelidays',
    aluguetemporada: 'Aluguetemporada',
    stayz: 'Stayz',
    bookabach: 'Bookabach'
};

// This currently only encompasses BEX and Vrbo brand domains
const tldMapping = {
    com: {
        br: 'pt_BR',
        tw: 'zh_TW',
        vn: 'vi_VN',
        sg: 'zn_HK'
    },
    jp: 'ja_JP',
    es: 'es_ES',
    co: {
        uk: 'en_GB',
        jp: 'ja_JP',
        kr: 'ko_KR',
        th: 'th_TH',
        id: 'id_ID'
    },
    it: 'it_IT',
    de: 'de_DE',
    fr: 'fr_FR',
    nl: 'nl_NL',
    gr: 'el_GR',
    pt: 'pt_PT',
    se: 'sv_SE',
    pl: 'pl_PL',
    no: 'nb_NO',
    dk: 'da_DK',
    fi: 'fi_FI'
};
const supportedLocales = [
    'en-US',
    'es-ES',
    'it-IT',
    'fr-FR',
    'de-DE',
    'ru-RU',
    'pt-BR',
    'ja-JP',
    'ko-KR',
    'vi-VN',
    'zh-CN',
    'zh-TW',
    'tr-TR',
    'nl-NL',
    'th-TH',
    'el-GR',
    'pt-PT',
    'en-GB',
    'sv-SE',
    'pl-PL',
    'nb-NO',
    'hr-HR',
    'da-DK',
    'es-CZ',
    'fi-FI',
    'hu-HU',
    'id-ID',
    'ar-SA',
    'es-XL',
    'zn-HK',
    'is-IS',
    'he-HE',
    'fr-CA',
    'ms-MY',
    'bg-BG'
];

const localeDefaults = {
    en: 'en_US',
    es: 'es_ES',
    it: 'it_IT',
    fr: 'fr_FR',
    de: 'de_DE',
    ru: 'ru_RU',
    pt: 'pt_PT',
    jp: 'ja_JP',
    ko: 'ko_KR',
    vi: 'vi_VN',
    zh: 'zh_CN',
    tr: 'tr_TR',
    nl: 'nl_NL',
    th: 'th_TH',
    el: 'el_GR',
    sv: 'sv_SE',
    pl: 'pl_PL',
    nb: 'nb_NO',
    hr: 'hr_HR',
    da: 'da_DK',
    fi: 'fi_FI',
    hu: 'hu_HU',
    id: 'id_ID',
    ar: 'ar_SA',
    zn: 'zn_HK',
    is: 'is_IS',
    he: 'he_HE',
    ms: 'ms_MY',
    bg: 'bg_BG'
};

const PIN_DELTA = 0.0015;

const PROPERTY_MANAGEMENT_IMAGE = 'https://headless.expediagroup.com/content/dam/marketing/headless/images/home-page//PM_Referral.webp';

const EMAIL_DUP_ERROR_MESSAGE = 'user.account.owner.exists.detailed';
const EMAIL_DUP_PUPS_ERROR_MESSAGE = 'validation.error.isDuplicateEmail';
const EMAIL_DUP_TRAVELER_ERROR_MESSAGE = 'user.account.traveler.exists.detailed';
const PHONE_VALIDATION_ERROR_MESSAGE = 'validation.error.phone';
const FAILED_ATO_SHIELD_CAPTCHA = 'Failed to validate ATO Shield captcha!';
const CLIENT_TIMEOUT_ERROR_MESSAGE = 'Client request timeout';


export {
    EMAIL_DUP_PUPS_ERROR_MESSAGE,
    EMAIL_DUP_ERROR_MESSAGE,
    EMAIL_DUP_TRAVELER_ERROR_MESSAGE,
    PHONE_VALIDATION_ERROR_MESSAGE,
    PIN_DELTA,
    boolAnswers,
    propertyTypes,
    softwareBrands,
    destinations,
    templates,
    themes,
    supportedBrands,
    supportedBrandNames,
    tldMapping,
    supportedLocales,
    localeDefaults,
    pathSources,
    pathUrls,
    PROPERTY_MANAGEMENT_IMAGE,
    egTemplatePages,
    FAILED_ATO_SHIELD_CAPTCHA,
    CLIENT_TIMEOUT_ERROR_MESSAGE
};
